import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  heading: {
    fontSize: 20,
    marginBottom: 10
  },
  technicianLabel: {
    fontSize: 24,
    marginBottom: 10,
    textAlign: 'center'
  },
  subheading: {
    fontSize: 20,
    marginBottom: 15
  },
  swapButton: {
    width: '100%'
  },
  paragraph: {
    fontSize: 14
  },
  box: {
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: '1px solid #b7b7b7'
  }
})

export default useStyles;